<template>
  <div class="row no-gutters">
    <div class="col-4">
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio-group
          v-model="selected"
          :aria-describedby="ariaDescribedby"
          name="radio-btn-stacked"
          buttons
          stacked>
          <b-form-radio :key="optionIndex" v-for="(option, optionIndex) in options" :value="option" :button-variant="option.color">
            {{ option.label }}
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
    </div>
    <div class="col">
      <b-card style="0;height: 93%; color: white; font-weight: bold" :border-variant="selected ? selected.color: null" :bg-variant="selected ? selected.color: null">
        <h4 class="text-white text-bold">Vincule para: <span class="text-uppercase">{{selected.label}}</span></h4>
        <div class="row">
          <div class="col-12">
              <v-select :options="formsList.map(form => ({ name: form.title, _id: form._id }))"
                        :reduce="option => option._id"
                        multiple
                        @input="changeForm"
                        v-model="forms[selected.value]"
                        label="name" />
          </div>
        </div>
      </b-card>
    </div>
    {{forms}}
  </div>
</template>

<script>
import {STATUS_TASKS_ARRAY} from "@/constants/tasks"
import {mapGetters} from "vuex";

export default {
  name: 'VinculateForms',
  props: {
    propForms: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      formsList: 'forms/forms'
    }),
  },
  mounted () {
    this.$store.dispatch('forms/getForms', {})
    this.init()
  },
  data () {
    return {
      forms: {
        WAITING: [],
        IN_PROGRESS: [],
        COMPLETED: [],
        CANCELED: [],
        IMPEDED: [],
      },
      selected: STATUS_TASKS_ARRAY[0],
      options: [
        ...STATUS_TASKS_ARRAY
      ]
    }
  },
  methods: {
    init () {
      if (Object.keys(this.propForms).length) {
        this.forms = this.propForms
      }
    },
    changeForm () {
      this.$emit('onChangeForm', this.forms)
    }
  }
}
</script>
